exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".milestone-icon {\r\n  font-size: 1.5em;\r\n  color: rgba(0,0,0,0.4);\r\n}\r\n\r\n.side-nav-text {\r\n  font-family: 'Pacifico', cursive;\r\n  font-size: 1.2em;\r\n  margin-top: 10px;\r\n  margin-bottom: 10px;\r\n  color: #282828;\r\n  text-align: center;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// F:/Home/Locker/About-me/about-me1/src/app/displayer/resume/resume.component.css
// module id = ../../../../../src/app/displayer/resume/resume.component.css
// module chunks = main